// gatsby-browser.js
import React, { useEffect } from 'react';

// Add loading class to body to prevent FOUC
export const onClientEntry = () => {
  if (typeof document !== 'undefined') {
    document.body.classList.add('no-fouc');
    // Show initial loading
    document.body.classList.add('loading');
  }
};

export const onRouteUpdate = () => {
  // Remove loading class when route changes
  if (typeof document !== 'undefined') {
    document.body.classList.remove('loading');
    document.body.classList.add('loaded');
  }
};

// Add loading class during route changes
export const onPreRouteUpdate = () => {
  if (typeof document !== 'undefined') {
    document.body.classList.add('loading');
  }
};

// Show loading during page transitions
export const onInitialClientRender = () => {
  if (typeof document !== 'undefined') {
    // Hide loading after initial render
    setTimeout(() => {
      document.body.classList.remove('loading');
      document.body.classList.add('loaded');
    }, 1000);
  }
};

// Avoid wrapping pages with the heavy SPA layout to reduce first-load JS
